/**
 * Mock current persona (manager scope) — used for "Mine" ownership and Take it.
 * Replaced by the persona/role from @aimsos/auth once the backend field lands.
 */
export const MOCK_CURRENT_PERSONA = {
  id: 'marcus-h',
  name: 'Marcus H.',
  initials: 'MH',
  role: 'manager',
  studio: 'governance-operations',
};

/**
 * Mock org directory. Ask / Forward / Reassign / Escalate and the thread @mention
 * composer now use the REAL directory (CT-5094 `listWorkspaceUsers`); this mock
 * remains ONLY for the Attestation "Request verification" picker, which needs the
 * rich fields (`role`, `department`, `tags`, `oooUntil`) that `list_filter` does
 * not return yet — tracked as **CT-5094 punto 5** — and whose attestations are
 * themselves mock (MOCK_ATTESTATIONS) pending the backend. Remove once punto 5
 * enriches the directory and the attestation endpoint lands.
 */
export const MOCK_PEOPLE = [
  {
    id: 'marcus-h',
    name: 'Marcus H.',
    initials: 'MH',
    role: 'Governance Lead',
    department: 'Risk',
    tags: ['Compliance', 'Finance', 'Truth Plane'],
    subtitle: 'Governance Lead · Risk',
  },
  {
    id: 'priya-k',
    name: 'Priya K.',
    initials: 'PK',
    role: 'Data Ops Manager',
    department: 'Data',
    tags: ['PII / Security', 'Data Ops'],
    subtitle: 'Data Ops Manager · Data',
  },
  {
    id: 'jordan-t',
    name: 'Jordan T.',
    initials: 'JT',
    role: 'Compliance Analyst',
    department: 'Risk',
    tags: ['Compliance', 'Truth Plane'],
    subtitle: 'Compliance Analyst · Risk',
  },
  {
    id: 'sam-r',
    name: 'Sam R.',
    initials: 'SR',
    role: 'Data Engineer',
    department: 'Data',
    tags: ['Data Ops'],
    subtitle: 'Data Engineer · Data',
  },
  {
    id: 'casey-v',
    name: 'Casey V.',
    initials: 'CV',
    role: 'Agentic Ops',
    department: 'AI Ops',
    tags: ['Agentic'],
    subtitle: 'Agentic Ops · AI Ops',
  },
  {
    id: 'devon-n',
    name: 'Devon N.',
    initials: 'DN',
    role: 'IT Security',
    department: 'IT',
    tags: ['PII / Security', 'Truth Plane', 'Data Ops'],
    subtitle: 'IT Security · IT',
  },
  {
    id: 'riley-p',
    name: 'Riley P.',
    initials: 'RP',
    role: 'Finance Analyst',
    department: 'Finance',
    tags: ['Finance', 'Truth Plane'],
    subtitle: 'Finance Analyst · Finance',
  },
  {
    id: 'taylor-b',
    name: 'Taylor B.',
    initials: 'TB',
    role: 'ML Engineer',
    department: 'AI Ops',
    tags: ['Data Ops', 'Agentic'],
    subtitle: 'ML Engineer · AI Ops',
  },
  {
    id: 'morgan-c',
    name: 'Morgan C.',
    initials: 'MC',
    role: 'Agentic Ops Lead',
    department: 'AI Ops',
    tags: ['Agentic'],
    subtitle: 'Agentic Ops Lead · AI Ops',
  },
  {
    id: 'quinn-s',
    name: 'Quinn S.',
    initials: 'QS',
    role: 'CTO',
    department: 'Executive',
    tags: ['Truth Plane', 'Data Ops', 'Agentic'],
    subtitle: 'CTO · Executive',
  },
  {
    id: 'luis-f',
    name: 'Luis F.',
    initials: 'LF',
    role: 'KB Curator',
    department: 'Knowledge',
    tags: ['Truth Plane', 'Knowledge Base'],
    oooUntil: '06-25',
    subtitle: 'KB Curator · Knowledge',
  },
  {
    id: 'priya-s',
    name: 'Priya S.',
    initials: 'PS',
    role: 'Compliance Reviewer',
    department: 'Risk',
    tags: ['Compliance', 'Truth Plane'],
    subtitle: 'Compliance Reviewer · Risk',
  },
  {
    id: 'marcus-a',
    name: 'Marcus A.',
    initials: 'MA',
    role: 'Governance Analyst',
    department: 'Risk',
    tags: ['Compliance', 'Truth Plane'],
    subtitle: 'Governance Analyst · Risk',
  },
  {
    id: 'jamie-c',
    name: 'Jamie C.',
    initials: 'JC',
    role: 'IT Operations',
    department: 'IT',
    tags: ['PII / Security', 'Truth Plane', 'Data Ops'],
    subtitle: 'IT Operations · IT',
  },
  {
    id: 'luis-r',
    name: 'Luis R.',
    initials: 'LR',
    role: 'Data Analyst',
    department: 'Data',
    tags: ['Data Ops'],
    subtitle: 'Data Analyst · Data',
  },
];

/** Escalation reasons (SelectableChip set) mirroring the prototype. */
export const ESCALATION_REASONS = [
  { value: 'needs_expert_input', labelKey: 'escalate.reasonNeedsExpertInput' },
  { value: 'conflicting_evidence', labelKey: 'escalate.reasonConflictingEvidence' },
  { value: 'high_risk', labelKey: 'escalate.reasonHighRisk' },
  { value: 'unclear_policy', labelKey: 'escalate.reasonUnclearPolicy' },
  { value: 'other', labelKey: 'escalate.reasonOther' },
];
